import SearchFilter from './SearchFilter'

export default SearchFilter



// WEBPACK FOOTER //
// ./src/components/SearchFilter/index.js